const removeComponentFromParent = () => allFields => allFields;

export default removeComponentFromParent;
